import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineChatEventsApi } from '@/features/api/hooks/grapevine-chat-events/useGrapevineChatApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

type MutationParams = {
  message?: string;
  temporaryMediaItemIds?: string[];
};

export const useStartChatOnComment = (commentId: string) => {
  const queryClient = useQueryClient();
  const grapevineApi = useGrapevineChatEventsApi();

  return useApiMutation({
    mutationFn: async ({ message, temporaryMediaItemIds }: MutationParams) =>
      grapevineApi.onClientChatStartOnCommentRequest({
        clientChatStartOnCommentRequest: {
          commentId,
          message,
          temporaryMediaItemIds,
          sentTime: Date.now()
        }
      }),
    errorMessageKey: 'startChat.error',
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT_MESSAGES, response.chat.id]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_CHATS]
      });
    }
  });
};
